import { useMemo } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getCustomerTransactionsTab } from '../../services/customers';

function useGetCustomerPaymentsTab({
  customerId,
  businessId,
}: {
  customerId: string;
  businessId: string;
}) {
  const query = useInfiniteQuery({
    queryKey: ['customer-payments-tab', { customerId, businessId }],
    queryFn: ({ pageParam }) =>
      getCustomerTransactionsTab({ customerId, businessId, cursor: pageParam }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: lastPage => lastPage.nextCursor ?? undefined,
    enabled: !!customerId && !!businessId,
  });

  const pages = query.data?.pages;
  const transactions = useMemo(
    () => pages?.flatMap(page => page.transactions) ?? [],
    [pages],
  );
  const totals = pages?.[0]?.totals ?? null;

  return {
    transactions,
    totals,
    isInitialLoading: query.isPending,
    isFetching: query.isFetching,
    isFetchingNextPage: query.isFetchingNextPage,
    hasMore: query.hasNextPage,
    loadMore: () => {
      query.fetchNextPage();
    },
    isError: query.isError && !query.data,
    isFetchNextPageError: query.isFetchNextPageError,
    error: query.error,
  };
}

export default useGetCustomerPaymentsTab;
